import { createApp } from 'vue'
import PrivacyPolicy from './privacyPolicy.vue';
import router from '../../router/mobileMenu.router'

createApp(PrivacyPolicy).use(router).mount('#privacyPolicy')